import React from 'react'
import { useSpring, animated, config } from 'react-spring'
import NavigationTwoSlidesLeft from './navigation-two-slides-left'
import NavigationTwoSlidesRight from './navigation-two-slides-right'
import './styles/navigation-two-slides.css'

const NavigationTwoSlides = ({ isNavOpen, toggleNavOpen }) => {
  const { x } = useSpring({
    x: isNavOpen ? 0 : 100,
    config: { mass: 1, tension: 190, friction: 24 }, // custom
    // config: { mass: 1, tension: 170, friction: 26 }, //config.default,
    // config: { mass: 1, tension: 280, friction: 120 }, // config.molasses
  })
  return (
    <div
      className="navigation-two-slides w3-row"
      style={{
        pointerEvents: isNavOpen ? 'all' : 'none',
      }}
    >
      <animated.div
        style={{
          transform: x.to((x) => `translate3d(${x * -1}%,0 , 0)`),
        }}
        className="navigation-two-slides-left"
      >
        <div className="w3-container">
          <NavigationTwoSlidesLeft toggleNavOpen={toggleNavOpen} />
        </div>
      </animated.div>
      <animated.div
        onClick={toggleNavOpen}
        style={{
          transform: x.to((x) => `translate3d(${x}%, 0, 0)`),
        }}
        className="navigation-two-slides-right"
      >
        <div className="w3-container">
          <NavigationTwoSlidesRight />
        </div>
      </animated.div>
    </div>
  )
}

export default NavigationTwoSlides


//https://dev.to/jsmanifest/create-a-modern-dynamic-sidebar-menu-in-react-using-recursion-36eo
//TODO: create dynamic navigation
//https://www.gatsbyjs.com/docs/creating-dynamic-navigation/
